import {
  createContext,
  useContext,
  useMemo,
  memo,
  ReactNode,
} from "react";
import { useFlowDataContext } from "./FlowDataContext";
import { useNodesPositionContext } from "./NodesPositionContext";

const NodesWithPositionContext = createContext<any>(null);
export const useNodesWithPositionContext = () =>
  useContext(NodesWithPositionContext);

const NodesWithPositionProvider = ({ children }: { children: ReactNode }) => {
  const { nodes } = useFlowDataContext();
  const { nodesPositionMap } = useNodesPositionContext();

  const nodesWithPosition = useMemo(() => {
    return nodes.map((node: any) => {
      const nextNode = { ...node };
      const position = nodesPositionMap[node.id];
      if (position) nextNode.position = position;
      return nextNode;
    });
  }, [nodes, nodesPositionMap]);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const contextValue = useMemo(() => ({ nodesWithPosition }), [nodesWithPosition]);

  return (
    <NodesWithPositionContext.Provider value={contextValue}>
      {children}
    </NodesWithPositionContext.Provider>
  );
};

export default memo(NodesWithPositionProvider);
